import React, { useState, useRef, useContext } from 'react'
import axios from 'axios'
import {
  Form,
  FormGroup,
  FormLabel,
  FormControl,
  Button,
} from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import config from '../../config/config'
import { LOGIN_PATH } from '../../config/routes'
import { useAuth, AuthContext } from '../../contexts/AuthContext'
import { setFlashMessage, useWebsite } from '../../contexts/WebsiteContext'

const ManagePoiAddExternalLink = ({ poi, handleAddLink }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { logout } = useContext(AuthContext)
  const { token } = useAuth()

  const [searchText, setSearchText] = useState('')
  const [searchResults, setSearchResults] = useState([])
  const [formData, setFormData] = useState({
    linkedExternalLinkId: null,
    linkedExternalLinkUrlFr: '',
    linkedExternalLinkLabelFr: '',
  })
  const inputRef = useRef(null)

  const handleSearchInputChange = async (event) => {
    const text = event.target.value
    setSearchText(text)
    if (text.trim() !== '' && text.trim().length >= 3) {
      try {
        const response = await axios.get(
          `${config.apiUrl}external-link?autocomplete=${text}`,
        )
        setSearchResults(response.data)
      } catch (error) {
        //console.error('An error occurred while searching for POIs:', error);
      }
    } else {
      setSearchResults([])
    }
  }

  const handleSelectExternalLink = (id, urlFr, labelFr) => {
    setFormData({
      linkedExternalLinkId: id,
      linkedExternalLinkUrlFr: urlFr,
      linkedExternalLinkLabelFr: labelFr,
    })
    setSearchText('')
    setSearchResults([])
  }

  const handleSubmit = async (event) => {
    event.preventDefault()
    try {
      await axios.post(
        `${config.apiUrl}poi-external-link`,
        {
          poiId: poi.id,
          linkedExternalLinkId: formData.linkedExternalLinkId,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )

      // Clear form data
      setFormData({
        linkedExternalLinkId: null,
        linkedExternalLinkUrlFr: '',
        linkedExternalLinkLabelFr: '',
      })
      handleAddLink()
      setFlashMessage(t('SUCCESS_CREATED_MESSAGE'), 'success')
    } catch (error) {
      //console.error('Error webservice call:', error);

      if (error.response && error.response.status === 401) {
        logout()
        navigate(LOGIN_PATH)
      } else if (error.response) {
        setFlashMessage(t('ERROR_MESSAGE'), 'error')
        console.log('Erreur lors du POST poi-external-link ', poi.id)
      }
    }
  }

  return (
    <div>
      <h2>{t('ADD')}</h2>
      <Form onSubmit={handleSubmit}>
        <FormGroup>
          <FormLabel>Lien externe à relier</FormLabel>
          <div className="green-frame" style={{ paddingBottom: '10px' }}>
            {formData.linkedExternalLinkUrlFr
              ? formData.linkedExternalLinkUrlFr
              : t('SELECT_AUTOCOMPLETE_MESSAGE')}
          </div>
        </FormGroup>
        <FormGroup>
          <FormLabel>Rechercher un lien externe à relier</FormLabel>
          <FormControl
            type="text"
            name="linkedExternalLink"
            value={searchText}
            onChange={handleSearchInputChange}
            ref={inputRef}
          />
          {searchResults.length > 0 && (
            <ul>
              {searchResults.map((externalLink) => (
                <li
                  key={externalLink.id}
                  onClick={() =>
                    handleSelectExternalLink(
                      externalLink.id,
                      externalLink.urlFr,
                      externalLink.labelFr,
                    )
                  }
                >
                  {externalLink.urlFr} - {externalLink.labelFr}
                </li>
              ))}
            </ul>
          )}
        </FormGroup>
        <div
          className="text-center margin-top-20"
          style={{ marginBottom: '60px' }}
        >
          <Button type="submit" disabled={!formData.linkedExternalLinkId}>
            {t('ADD')}
          </Button>
        </div>
      </Form>
    </div>
  )
}

export default ManagePoiAddExternalLink
